import { useEffect, useState } from "react";
import { getSiteConsent } from "../../../../services/medereSiteController";
import DOMPurify from "dompurify";

export default function ConsentTab() {
    
    const [consentHTML, setConsentHTML] = useState<string | null>(null);

    useEffect(() => {   
        getSiteConsent().then((consent) => setConsentHTML(DOMPurify.sanitize(consent)));
    }, []);

    return <div className="consent-content" dangerouslySetInnerHTML={{ __html: consentHTML }} />;
}
